// scrollNumber.js
export default {
  bind(el, binding) {
    let end = binding.value.end;
    let duration = binding.value.duration || 2000; // 如果没有传入参数，则默认为 2000 毫秒
    let digits = end.toString().split('').map(Number); // 将结束的数字分解为各个位数
    let currentDigits = Array(digits.length).fill(0); // 初始化当前的数字
    let timer = null;
    let animationTriggered = false;

    let f = function() {
      let rect = el.getBoundingClientRect();
      let inView = (rect.top >= 0) && (rect.bottom <= window.innerHeight);
      if (inView && !animationTriggered) {
        animationTriggered = true;
        if (timer !== null) {
          clearInterval(timer);
        }
        let startTime = Date.now();
        timer = setInterval(function() {
          let progress = (Date.now() - startTime) / duration;
          for (let i = 0; i < digits.length; i++) {
            currentDigits[i] = Math.min(Math.floor(digits[i] * progress), digits[i]);
          }
          el.innerText = currentDigits.join('');
          if (progress >= 1) {
            el.innerText = end;
            clearInterval(timer);
          }
        }, 16);
      } else if (!inView) {
        animationTriggered = false;
        if (timer !== null) {
          clearInterval(timer);
        }
        el.innerText = 0;
      }
    };
    window.addEventListener('scroll', f);
  }
};



// WEBPACK FOOTER //
// ./src/components/scrollNumber.js